import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DashboardAccessService } from './dashboard-access.service';
import { DashboardAccess } from '../utils/dashboard.models';

@Injectable()
export class DashboardContextService {
  private static readonly defaultAccess: DashboardAccess = {
    hasCapex: false,
    hasOpex: false,
    hasCombinedFromRights: false
  };

  private readonly accessSubject = new BehaviorSubject<DashboardAccess>({
    ...DashboardContextService.defaultAccess
  });
  private readonly accessResolvedSubject = new BehaviorSubject<boolean>(false);

  readonly access$ = this.accessSubject.asObservable();
  readonly accessResolved$ = this.accessResolvedSubject.asObservable();

  constructor(private readonly accessService: DashboardAccessService) { }

  refresh(): void {
    this.accessResolvedSubject.next(false);
    this.accessService.access$.pipe(take(1)).subscribe({
      next: (access) => {
        this.accessSubject.next(access);
        this.accessResolvedSubject.next(true);
      },
      error: () => {
        this.accessSubject.next({ ...DashboardContextService.defaultAccess });
        this.accessResolvedSubject.next(true);
      }
    });
  }
}
